import React from 'react'
import { useNavigate } from 'react-router-dom';
import Navbar from '../MenuLayout/Navbar/Navbar';
import { useSelector } from 'react-redux';
import { MainTabContentActiveTab, MainTabContentTabList } from '../../actions/SidebarAction';
import { useDispatch } from 'react-redux';
import { ServerRequestProtected } from '../../utils/ServerDataRequest';
import { enumUtil } from '../../utils/Enum';
import packageJson from "../../../package.json"

const UserTimeout = ({ handleResume }) => {
  const API_URL = enumUtil.controller.General
  let navigate = useNavigate();
  let dispatch = useDispatch();
  const stateRedux = useSelector(state => state);

  const checkTokenValidaty = async () => {
    try {
      const response = await ServerRequestProtected(API_URL + "/CheckTokenValidity", 'post', {});
      console.log('checkTokenValidaty', response);
      if (response.error === "Token is valid") {
        return true; // Token is valid
      } else return false
    } catch (error) {
      return false; // Token is invalid
    }
  };

  const handleContinue = async () => {
    const isTokenValid = await checkTokenValidaty();
    handleResume(isTokenValid);
    // navigate("../pms", { replace: true });
    // if(!stateRedux.SidebarActiveTab) return
    // setTimeout(() => handleOpenMainTab(stateRedux.SidebarActiveTab),0)
  };

  ///////////Handle Open Main Tab//////////
  //  const handleOpenMainTab = (key) => {
  //     const isTabExist = [...stateRedux.SidebarList].filter((tab) => {
  //         if (tab.key === key) {
  //             tab.time = new Date()
  //             return tab
  //         }
  //         return tab
  //     })
  //     dispatch(MainTabContentActiveTab(key))
  //     dispatch(MainTabContentTabList(isTabExist));
  // }
  const year = new Date().getFullYear();
  const ThemeConfiguration = useSelector((state) => state.Theme?.theme) || JSON.parse(localStorage.getItem("themeConfig") || "null");

  const isTobNav = ThemeConfiguration?.configuration?.navigation?.type === 'TopBar';
  return (
    <div className={`layout row g-0 usertime_out ${isTobNav ? 'Top-NavBar' : ''}`}>
      {isTobNav ?
        <>
          <div className="layout d-block m-0 h-auto">
            <div className="app-container rounded-0 overflow-visible">
              <Navbar />
            </div>
          </div>

          <div className="sidebar hk-sidebar-v1 ar_top-sidebar d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center gap-30 h-100">
              <div className="empty-cell h-100"></div>
              <div className="empty-cell"></div>
              <div className="empty-cell"></div>
              <div className="empty-cell"></div>
              <div className="empty-cell"></div>
              <div className="empty-cell"></div>
              <div className="empty-cell"></div>
              <div className="empty-cell"></div>
              <div className="empty-cell"></div>
            </div>

            <div className="d-flex align-items-center gap-12">
              <div className="empty-cell ar-w-21"></div>
              <div className="empty-cell ar-w-21"></div>
              <div className="ar-border-line"></div>
                  <div className="empty-cell ar-h-30"></div>
            </div>
          </div>
        </>
        :
        <React.Fragment>
          <nav className="sidebar hk-sidebar-v1 col-md-3 col-lg-2 px-0">
            <div className="sidebar-header time_out">
              <div className="d-flex gap-3 flex-column-reverse user-view w-100">
                <span className='lines w-100'></span>
                <span className='lines w-100 mt-4'></span>
                <div className="user-info">
                  <p className="heading text-white">
                    {/* {userDetail.Name} */}
                  </p>
                  <p className="text clr-light font-m">
                    {/* {userDetail.RoleName} */}
                  </p>
                </div>
              </div>
              <button className="toggle-sidebar"
              // onClick={toggleSidebar}
              >
                <i className="icon-right-direction"></i>
              </button>
            </div>
            <div className="menu-list-container">
              <ul className="menu-lists top mt-5">
                <span className='lines'></span>
                <span className='lines my-2'></span>
                <span className='lines'></span>
              </ul>

              {/* <ul className="menu-lists bottom">
                       <span className='lines mx-3'></span>
                       <span className='lines mx-3'></span>
                    </ul> */}
            </div>
          </nav>
        </React.Fragment>
      }
      <div className='app-container col-md-9 col-lg-10 px-0'>
        {isTobNav ? null : <Navbar />}
        <div className='app-content'>
          <div className='ar-Show_message'>
            <p className='md_text font-m'> <i className='icon-Vector2'></i> Your session has expired due to inactivity, <span className='text-primary ar-br-bottom cursor-pointer'
              onClick={handleContinue}> Click here </span>to resume</p>
          </div>
        </div>
        <div className="footer ">
          <p className="text">© {year} {ThemeConfiguration?.configuration?.company?.name}. All rights reserved. v{packageJson.version}</p>
          <p className="tool_tip heading">Need Help? </p>
        </div>
      </div>
    </div>
  )
}

export default UserTimeout